import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const ErrorWrapper = styled.div`
  display: flex;
  padding-top: 43px;
  width: 55%;
  ${mediaQueries.tablet`
    width: 100%;
  `};
`

export const ErrorText = styled.div.attrs(() => ({
  className: e2eClasses('searchBox.reserveErrorBox')
}))`
  display: flex;
  flex-direction: column;
`

export const ErrorTitle = styled.div.attrs(() => ({
  className: e2eClasses('searchBox.reserveErrorTitle')
}))`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 20px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  margin-bottom: 16px;
  width: 85%;
`

export const ErrorMessage = styled.p.attrs(() => ({
  className: e2eClasses('searchBox.reserveErrorMessage')
}))`
  color: ${({ theme }) => theme.colors.doveGray};
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.regular};
`

export const StyledLink = styled.a`
  margin-top: 8px;
  font-size: 14px;
`

export const ErrorImage = styled.img.attrs(() => ({
  className: e2eClasses('searchBox.reserveErrorImage')
}))`
  margin-left: 40px;
`
